import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(consent-manger)/[locale]/(lagacy-footer)/document/[...segments]/LegislationDetails.tsx");
